import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ErrorDialogComponent } from '../../../dialogs/error-dialog/error-dialog.component';
import { Paciente } from '../../../paciente/paciente';
import { Util } from '../../../util/util';
import { TipoMarcacaoEnum } from '../../../enums/tipo-marcacao-enum';

@Component({
  selector: 'app-cadastro-dependente',
  templateUrl: './cadastro-dependente.component.html',
  styleUrls: ['./cadastro-dependente.component.css']
})
export class CadastroDependenteComponent implements OnInit {

  paciente: Paciente;

  formularioDeDependente: FormGroup;

  tipoMarcacao: TipoMarcacaoEnum = TipoMarcacaoEnum.TIPO_MARCACAO_CONSULTA;

  constructor(private router: Router, private formBuilder: FormBuilder,
    private dialog: MatDialog) {

    this.paciente = history.state.pacienteTitular;

    this.tipoMarcacao = history.state.tipoMarcacao;

    this.formularioDeDependente = this.formBuilder.group({
      nome: ['', [Validators.required, Validators.minLength(6)]],
      dataNascimento: ['', [Validators.required, Util.dataInvalida]],
      dependentes: [[]],
    });
  }

  ngOnInit(): void {
    if (!this.paciente) {
      this.dialog.open(ErrorDialogComponent, {
        data: {
          title: 'Erro',
          message: 'Não será possível cadastrar o Dependente. Titular não encontrado.'
        }
      });
    }
    if (!this.tipoMarcacao) {
      this.dialog.open(ErrorDialogComponent, {
        data: {
          title: 'Erro',
          message: 'Não será possível cadastrar o Dependente. Tipo de Marcação não encontrado.'
        }
      });
    }
  }

  onSubmit() {
    this.save();
  }

  save() {
    if (!this.temDependenteCadastradoComEsteNome()) {
      if (!this.paciente?.dependentes) {
        this.paciente.dependentes = new Array<Paciente>();
      }

      this.paciente.dependentes.push(this.formularioDeDependente.value);

      this.voltarPaginaAnterior();
    } else {
      this.dialog.open(ErrorDialogComponent, {
        data: {
          title: 'Erro',
          message: 'Já existe um Dependente cadastrado com esse nome!'
        }
      });
    }
  }

  temDependenteCadastradoComEsteNome(): boolean {
    let existe: boolean = false;

    if (this.paciente && this.formularioDeDependente.value) {

      if (this.paciente.dependentes) {

        for (let dependenteAtual of this.paciente.dependentes) {
          if (dependenteAtual.nome.toUpperCase() === this.formularioDeDependente.value.nome) {
            existe = true;
            break;
          }

        }

      }

    }

    return existe;
  }

  voltarPaginaAnterior(): void {
    this.router.navigate(['/marcacaoConsulta/cadastrarPaciente'], {
      state: {
        pacienteTitular: this.paciente,
        tipoMarcacao: this.tipoMarcacao,
        agendamentos: history.state.agendamentos
      }
    });
  }
}
